export default "/kiban/_next/static/images/41_12L_none-6e9f5c0c20c8c8e1f9e4f08c3336f10e.png";